import {
  Card,
  Tag,
  Typography,
  Table,
  Space,
  Drawer,
  Progress,
  Select,
} from "antd";
import classes from "./RealTimeTrends.module.scss";
import { ArrowUpOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { defaultTrends, NewsType, queryKeys } from "../../constants";
import {
  companyNewsColumns,
  companyNewsData,
  covid19Columns,
  covid19Data,
  marketHolidaysColumns,
  marketHolidaysData,
  marketTrendsColumns,
  marketTrendsData,
} from "./constants";
import { useQuery } from "@tanstack/react-query";
import { fetchMarketNews } from "../../services/scenarios";
import { useNavigate } from "react-router-dom";
import Dashboard from "../Dashboard";
const { Title, Text } = Typography;

const RealTimeTrends = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [selectedTrend, setSelectedTrend] = useState(null);
  const [args, setArgs] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [selectedChart, setSelectedChart] = useState(defaultTrends[0].value);

  const [selectedTrendTable, setSelectedTrendTable] = useState({
    columns: marketTrendsColumns, // default columns to display
    dataSource: marketTrendsData, // default data to display
  });

  const {
    data: marketNews,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: [
      queryKeys.getMarketNewsTrends,
      args.current,
      args.pageSize,
      args.news_type,
    ],
    queryFn: () => fetchMarketNews(args.current, args.pageSize, args.news_type),
  });

  useEffect(() => {
    if (selectedChart === "market_news") {
      setSelectedTrendTable({
        columns: companyNewsColumns,
        dataSource: marketNews?.data?.results,
      });
      setArgs((prev) => ({
        ...prev,
        total: marketNews?.data?.count,
      }));
    }
  }, [marketNews?.data, selectedChart]);

  const handleRowClick = (record) => {
    record.article_id &&
      navigate(`/home/real-time-trends-detail/${record.article_id}`);
  };

  const closeDrawer = () => {
    setVisible(false);
    setSelectedTrend(null);
  };

  const handleChange = (value) => {
    setSelectedChart(value);
    switch (value) {
      case "market_status":
        setSelectedTrendTable({
          columns: marketTrendsColumns,
          dataSource: marketTrendsData,
        });
        break;
      case "market_holidays":
        setSelectedTrendTable({
          columns: marketHolidaysColumns,
          dataSource: marketHolidaysData,
        });
        break;
      case "covid19":
        setSelectedTrendTable({
          columns: covid19Columns,
          dataSource: covid19Data,
        });
        break;
      case "company_news":
        setSelectedTrendTable({
          columns: companyNewsColumns,
          dataSource: companyNewsData,
        });
        break;
      case "market_news":
        setSelectedTrendTable({
          columns: companyNewsColumns,
          dataSource: marketNews?.data?.results,
        });
        setArgs((prev) => ({
          ...prev,
          current: 1,
          news_type: null,
          total: marketNews?.data?.count,
        }));
        break;
      default:
        setSelectedTrendTable({
          columns: [],
          dataSource: [],
        });
        break;
    }
  };

  const handleTableChange = (newPagination) => {
    setArgs((prev) => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    }));
  };

  return (
    <>
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0, marginBottom: 0 }}>
          Real Time Trends
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Real-time trend tracking involves continuously monitoring various data
          sources, such as social media, news outlets, and industry reports.
        </Text>
      </div>

      <Dashboard />

      {/* <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
        <Select
          title="Select Charts"
          placeholder="Please select trend to display"
          showSearch
          options={defaultTrends}
          style={{
            width: selectedChart === "market_news" ? "50%" : "100%",
            marginBottom: 20,
          }}
          onChange={handleChange}
          defaultValue={selectedChart}
        />
        {selectedChart === "market_news" && (
          <Select
            title="Select Type"
            placeholder="Please select news type"
            options={NewsType}
            style={{ width: "50%" }}
            onChange={(value) =>
              setArgs((prev) => ({
                ...prev,
                current: 1,
                news_type: value,
              }))
            }
          />
        )}
      </div>
      <Table
        dataSource={selectedTrendTable.dataSource ?? []}
        columns={selectedTrendTable.columns ?? []}
        loading={isLoading || isFetching}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
        onChange={handleTableChange}
        pagination={{
          current: args.current,
          pageSize: args.pageSize,
          total: args.total,
        }}
      />
      <Drawer
        title={selectedTrend?.trend}
        placement="right"
        onClose={closeDrawer}
        open={visible}
        width={400}
      >
        {selectedTrend && (
          <div>
            <Card hoverable bordered className={classes.customCard}>
              <div className={classes.cardHeader}>
                <div className={classes.graphHeader}>
                  <span className={classes.title}>In Progress Scenarios</span>
                  <span className={classes.subTitle}>
                    Lorem ipsum is a dummy text
                  </span>
                </div>
                <span className={classes.positivePercentage}>
                  <ArrowUpOutlined /> 28%
                </span>
              </div>
              <div className={classes.progressContainer}>
                <Progress
                  type="circle"
                  steps={0}
                  percent={80}
                  trailColor="rgba(0, 0, 0, 0.06)"
                  strokeWidth={15}
                  size={100}
                />
              </div>
            </Card>
            <h3>Search Volume</h3>
            <Space direction="vertical">
              <span>{selectedTrend.searchVolume}</span>
              <Tag color="green">+{selectedTrend.change}</Tag>
            </Space>
            <h3 style={{ marginTop: "20px" }}>Trend breakdown</h3>
            <div>
              {selectedTrend.breakdown.map((item, index) => (
                <Tag key={index}>{item}</Tag>
              ))}
            </div>
          </div>
        )}
      </Drawer> */}
    </>
  );
};
export default RealTimeTrends;
